import axios, {AxiosRequestConfig} from 'axios';

import {ApiSuccessResponse} from './types';

export function httpDelete<T>(url: string, data?: AxiosRequestConfig['data']) {
  return axios.delete<ApiSuccessResponse<T>>(url, data);
}
